@layer reset, default, disabled, error, focus;

@layer reset {
  :host {
    display: block;

    .gcds-input-wrapper {
      margin: 0;
      padding: 0;
      border: 0;

      input {
        box-sizing: border-box;
      }
    }
  }
}

@layer default {
  :host .gcds-input-wrapper {
    max-width: 75ch;
    width: 100%;
    font: var(--gcds-input-font-desktop);
    color: var(--gcds-input-default-text);
    transition: color ease-in-out 0.15s;

    @media only screen and (width < 48em) {
      font: var(--gcds-input-font-mobile);
    }

    input {
      display: block;
      min-width: var(--gcds-input-min-width-and-height);
      width: 100%;
      max-width: 100%;
      height: auto;
      min-height: var(--gcds-input-min-width-and-height);
      font: inherit !important;
      margin: var(--gcds-input-margin) !important;
      padding: var(--gcds-input-padding) !important;
      background-color: var(--gcds-input-default-background);
      background-image: none;
      color: var(--gcds-input-default-text);
      border: var(--gcds-input-border-width) solid currentColor;
      border-radius: var(--gcds-input-border-radius);
      transition:
        border-color ease-in-out 0.15s,
        box-shadow ease-in-out 0.15s,
        outline ease-in-out 0.15s;

      /* Hide number arrows */
      &[type='number'] {
        -moz-appearance: textfield;

        &::-webkit-outer-spin-button,
        &::-webkit-inner-spin-button {
          -webkit-appearance: none;
        }
      }
    }
  }
}

@layer disabled {
  :host .gcds-input-wrapper.gcds-disabled {
    color: var(--gcds-input-disabled-text);

    gcds-label {
      --gcds-label-text: currentColor;
    }

    gcds-hint {
      --gcds-hint-text: currentColor;
    }

    input:disabled {
      cursor: not-allowed;
      background-color: var(--gcds-input-disabled-background);
      border-color: var(--gcds-input-disabled-text);
    }
  }
}

@layer error {
  :host .gcds-input-wrapper input.gcds-error:not(:focus) {
    border-color: var(--gcds-input-danger-border);
  }
}

@layer focus {
  :host .gcds-input-wrapper:focus-within input:focus {
    border-color: var(--gcds-input-focus-border);
    outline: var(--gcds-input-outline-width) solid
      var(--gcds-input-focus-border);
    outline-offset: var(--gcds-input-border-width);
    box-shadow: var(--gcds-input-focus-box-shadow);
  }
}
